export type ThemePreference = 'dark' | 'light' | 'system'

export const THEME_KEY = 'dlt.v1.theme'

/** Reads the stored preference, tolerating private-mode storage failures. */
export function readThemePreference(): ThemePreference {
    try {
        const v = localStorage.getItem(THEME_KEY)
        if (v === 'dark' || v === 'light' || v === 'system') return v
    } catch {
        // Safari private mode throws on storage access
    }
    return 'system'
}

export function storeThemePreference(pref: ThemePreference): void {
    try {
        if (pref === 'system') localStorage.removeItem(THEME_KEY)
        else localStorage.setItem(THEME_KEY, pref)
    } catch {
        // preference simply will not persist; the UI still works this session
    }
}

/**
 * Stamps the root element. `system` removes the attribute so the
 * prefers-color-scheme media query in tokens.css takes over again.
 */
export function applyTheme(pref: ThemePreference): void {
    const root = document.documentElement
    if (pref === 'system') root.removeAttribute('data-theme')
    else root.setAttribute('data-theme', pref)
}

/** What the user will actually see, resolving `system` against the OS. */
export function resolveTheme(pref: ThemePreference): 'dark' | 'light' {
    if (pref !== 'system') return pref
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
}
